import React, { useEffect, useState } from "react";
import "./LanguageToggle.css"; // Import the CSS file for styling
import { useTranslation } from "react-i18next";


const stored_lang = localStorage.getItem("language") || "bn"; // default bn

const LanguageToggle = () => {
  const { i18n } = useTranslation();
  const [lang, setLang] = useState(stored_lang);

  const toggleLanguage = () => {
    const newLanguage = lang === "en" ? "bn" : "en";
    setLang(newLanguage);
  };

  useEffect(() => {
    localStorage.setItem("language", lang);
    i18n.changeLanguage(lang);
  }, [lang, i18n]);

  const isEnglish = lang === "en";

  return (
<div className="p-3">
  <button
    onClick={toggleLanguage}
    className="relative w-32 h-8 bg-gray-400/30 rounded-full border border-gray-400/40 transition-all duration-300 hover:bg-gray-200/40 focus:outline-none focus:ring-2 focus:ring-[#2F4B7C] overflow-hidden"
    aria-label={`Switch to ${isEnglish ? "Bengali" : "English"}`}
  >
    {/* Next-language indicator (opposite end, dimmed) */}
    <div
      className={`absolute top-[2.5px] w-6 h-6 text-[#2F4B7C]/60 bg-gray-300/60 text-xs rounded-full flex items-center justify-center z-0 ${
        isEnglish ? "translate-x-1" : "translate-x-24"
      }`}
    >
      {isEnglish ? (
        <div className="h-3.5 w-3.5">ব</div>
      ) : (
        <div className="h-3.5 w-3.5 text-[0.62rem]">EN</div>
      )}
    </div>

    {/* Moving Knob (current active language) */}
    <div
      className={`absolute top-[2.5px] w-6 h-6 text-white bg-[#2F4B7C] text-xs rounded-full shadow-md flex items-center justify-center transition-transform duration-300 ease-in-out z-10 ${
        isEnglish ? "translate-x-24" : "translate-x-1"
      }`}
    >
      {isEnglish ? (
        // <img src={english} alt="" className=" rounded-full" />// EN icon
        <div className="h-3.5 w-3.5 text-[0.62rem]">EN</div>
      ) : (
        // <Languages className="h-3.5 w-3.5 text-white" /> // বাংলা icon
        //<img src={bangla} alt="" className=" rounded-full" />
             <div className="h-3.5 w-3.5">ব</div>
      )}
    </div>

    {/* Labels */}
    <div className="absolute inset-0 flex items-center justify-center">
      <span
        className={`text-xs font-semibold text-[#2F4B7C] transition-opacity duration-300 ${
          isEnglish ? "opacity-100" : "opacity-0"
        }`}
      >
English
      </span>
      <span
        className={`absolute text-xs font-semibold text-[#2F4B7C] transition-opacity duration-300 ${
          !isEnglish ? "opacity-100" : "opacity-0"
        }`}
      >
বাংলা
      </span>
    </div>
  </button>
  <p className="text-[10px] text-gray-500 mb-[6px]">
    {isEnglish ? "ভাষা পরিবর্তন করতে ক্লিক করুন" : "Click to switch language"}
  </p>
</div>

  );
};

export default LanguageToggle;
